import React from 'react';
import { Platform, StyleProp } from 'react-native';

import { IconButton } from '@/components/ui';
import { openPrintRoute } from '@/utils/print-navigation';

export const PrintButton: React.FC<{
	disabled?: boolean;
	url: string;
	style?: StyleProp<any>;
	size?: number;
}> = ({
	disabled,
	url,
	style = { margin: 0 },
	size = 24,
}) => {
	if (Platform.OS !== 'web') {
		return null;
	}

	/**
	 * Through the shared helper, which this used to duplicate by hand.
	 *
	 * `openPrintRoute` exists so the next print button cannot get this wrong, and this one
	 * was already getting it slightly wrong: a bare `window.open(url, '_blank')` omits
	 * `noopener,noreferrer`, so the print tab keeps a live `window.opener` handle back to
	 * the app.
	 */
	const handlePrint = () => openPrintRoute(url);

	return (
		<IconButton
			icon="print-outline"
			size={size}
			style={style}
			disabled={disabled}
			onPress={handlePrint}
		/>
	);
};
